
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><g clip-path='url(#clip0_17:17281)'><path d='M6.99998 7.55999C6.99998 6.61999 5.85998 6.13999 5.18998 6.80999L0.70998 11.29C0.31998 11.68 0.31998 12.31 0.70998 12.7L5.18998 17.18C5.85998 17.86 6.99998 17.38 6.99998 16.44C6.99998 16.16 6.88998 15.89 6.68998 15.69L2.99998 12L6.68998 8.30999C6.88998 8.10999 6.99998 7.83999 6.99998 7.55999ZM13 8.99999V7.40999C13 6.51999 11.92 6.06999 11.29 6.69999L6.69998 11.29C6.30998 11.68 6.30998 12.31 6.69998 12.7L11.29 17.29C11.92 17.92 13 17.47 13 16.58V14.9C18 14.9 21.5 16.5 24 20C23 15 20 9.99999 13 8.99999Z' fill='#323232'/></g><defs><clipPath id='clip0_17:17281'><rect width='24' height='24' fill='white'/></clipPath></defs></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-reply-all`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconReplyAll

    ```js
    <b-new-b-icon-reply-all />
    ```
</docs>


